import React, {useEffect, useState} from "react";
import styles from "./UIMessageImage.module.scss";
import LazyImage from "./LazyImage";
import _ from "lodash";
import {getUrl} from "src/service/files.service";

const UIMessageImage = ({
  handlePreviewImage,
  isAnother,
  msgObj,
  messageURLlocal,
  messageDetails,
  key
}: any) => {
  const fileServiceDownloadURL =
    window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/downloadFile?fileId=";
  let countItem = 0;
  const countFile = messageURLlocal
    ? messageURLlocal?.imageDetails?.length
    : messageDetails?.imageDetails?.length ||
      messageDetails?.fileDetails?.length;
  const imgFiles = messageURLlocal
    ? messageURLlocal?.imageDetails
    : messageDetails?.imageDetails || messageDetails?.fileDetails;

  // console.log("imgFiles : ", imgFiles);
  
  // console.log("msgObj", msgObj);
  

  return (
    <div
      key={key}
      className={styles.boxGroupImg}
      style={{
        marginLeft: "auto",
        maxWidth: isAnother > 1 ? "250px" : "",
        height: "auto",
      }}
    >
      {imgFiles?.map((itemImg: any, index: any) => {
        // console.log("itemImg : ", itemImg);
        
        countItem++;
        return (
          <UIMessageImageItem
            index={index}
            imgFiles={imgFiles}
            countItem={countItem}
            countFile={countFile}
            isAnother={isAnother}
            messageDetails={messageDetails}
            msgObj={msgObj}
            itemImg={itemImg}
            messageURLlocal={messageURLlocal}
            fileServiceDownloadURL={fileServiceDownloadURL}
            handlePreviewImage={handlePreviewImage}
          />
        );
      })}
    </div>
  );
};

const UIMessageImageItem = ({
  index,
  imgFiles,
  countItem,
  countFile,
  isAnother,
  messageDetails,
  msgObj,
  itemImg,
  messageURLlocal,
  fileServiceDownloadURL,
  handlePreviewImage,
}: any) => {
  const [url, setUrl]: any = useState("");

  const checkGetUrlFile = async () => {
    let urlImg: any = fileServiceDownloadURL + itemImg.id + "&size=300";
    if (itemImg?.id) {
      urlImg = await getUrl(urlImg, itemImg.id, 300, "chat");
    }
    console.log("urlImg : ", urlImg);
    setUrl(urlImg);
  };

  const renameKeys = (obj: any, newKeys: any) => {
    const keyValues = Object.keys(obj).map(key => {
      const newKey = newKeys[key] || key;
      return { [newKey]: obj[key] };
    });
    return Object.assign({}, ...keyValues);
  }
  
  useEffect(() => {
    checkGetUrlFile();
  }, []);

  const checkMessageDetails = () => {
    if (messageDetails?.imageDetails === undefined) {
      const newKeys = {fileDetails:"imageDetails"}
      messageDetails = renameKeys(messageDetails, newKeys);
    }
    if (messageDetails?.imageDetails?.[index]) {
      return messageDetails?.imageDetails?.[index];
    } else {
      return null;
    }
  }

  return (
    <div
      key={index}
      className={
        imgFiles?.length === 1
          ? styles.imgPreview
          : countItem === countFile && countItem % 2 > 0
          ? styles.imgPreview0
          : isAnother > 1
          ? styles.imgPreview2
          : styles.imgPreview1
      }
      // style={{ float: isAnother > 1 ? "right" : "left" }}
      style={{ float: "left" }}
    >
      <LazyImage
        imageDetails={checkMessageDetails()}
        handleClick={() => {
          var file = messageDetails?.imageDetails?.[index]
          || messageDetails?.fileDetails?.[index];
          console.log("handleClick", file);
          if (file?.id) {
            handlePreviewImage(
              "image",
              file?.fileName,
              file?.id,
              "old",
              file,
              msgObj,
              index
            );
          } else {
            handlePreviewImage(
              "image",
              itemImg?.name,
              URL.createObjectURL(itemImg),
              "new",
              itemImg,
              msgObj,
              index
            );
          }
        }}
        src={itemImg?.id ? url : itemImg}
        id={itemImg?.id ? itemImg?.id : "img" + index}
        isNewImage={itemImg?.id ? false : true}
        localImage={
          !_.isEmpty(messageURLlocal)
            ? messageURLlocal?.imageDetails[index]
            : null
        }
      />
    </div>
  );
};

export default React.memo(UIMessageImage);
